import React from "react";
import ReturnBackBtn from "../../atoms/ReturnBackBtn/ReturnBackBtn";
import { useNavigate } from "react-router-dom";

function GenericGoBackBtn({ label = "Retourner", to, linkToIfNoHistory, replace }: { label?: string; to?: string, linkToIfNoHistory?: string, replace?: boolean }) {
  const navigate = useNavigate();
  const hasPreviousPageInApp = window.history.state && window.history.state.idx > 0;
  return (
    <>
   

      {/* Lien explicite qui remplace l'entrée courante de l'historique */}
      {to && replace ? (
        <ReturnBackBtn label={label} onClick={() => navigate(to, { replace: true })} />
      ) : (hasPreviousPageInApp || linkToIfNoHistory) && (
        <ReturnBackBtn label={label} onClick={() => navigate(-1)} linnkTo={linkToIfNoHistory && !hasPreviousPageInApp ? linkToIfNoHistory : to} />
      )}
    </>
  );
}

export default GenericGoBackBtn;
